/* eslint-disable @typescript-eslint/no-shadow */

import { StoreSlice } from '../types';

export declare type AnyObject = { [key: string]: any; };

type Locale = string;

export declare interface AppConfig<Locale> extends AnyObject {
  locale: Locale;
  translations: AnyObject;
}

export type LocaleConfig = AppConfig<Locale>;

export interface ILocaleSlice {
  locale?: Locale;
  localeLoading: boolean;
  localeConfig: LocaleConfig | null;
  setLocale: (v:Locale) => void;
  setLocaleConfig: (v:LocaleConfig) => void;
}

const createLocaleSlice: StoreSlice<ILocaleSlice> = (set) => ({
  locale: undefined,
  localeLoading: true,
  setLocale: (v) => set((state) => {
    state.locale = v;
  }),
  setLocaleConfig: (v) => set((state) => {
    state.localeConfig = v;
    state.locale = v.locale;
    state.localeLoading = false;
  }),
  localeConfig: null,
});

export default createLocaleSlice;
